export const paths = {
  labs: () => '/labs',
  uiForm: () => '/labs/ui-form',
  stateForm: () => '/labs/state-form',
  newStateForm: () => '/labs/new-state-form',
  files: () => '/labs/files',
}
